import _extends from "@babel/runtime/helpers/extends";
import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import entityComposition from '../common/classes/entityComposition';
import DateTimePicker from '../common/controls/dateTimePicker';
import SinglePicker from '../common/controls/singlePicker';
import NumberInput from '../common/controls/numberInput';
import TextInput from '../common/controls/textInput';
class AssetProfile extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    const _this$props = this.props,
      assetColor = _this$props.assetColor,
      assetColorActions = _this$props.assetColorActions;
    assetColorActions.serverIndex(assetColor.indexQuery);
  }
  handleChange(fieldName, value) {
    const _this$props2 = this.props,
      assetID = _this$props2.asset.id,
      assetActions = _this$props2.assetActions;
    assetActions.change(assetID, fieldName, value);
  }
  render() {
    const _this$props3 = this.props,
      assetColor = _this$props3.assetColor,
      asset = _this$props3.asset;
    const year = asset.year,
      purchaseDate = asset.purchaseDate,
      estimatedValue = asset.estimatedValue,
      assetColorID = asset.assetColorID;

    // Convert the date value and propagate up
    const handleChangeYear = value => this.handleChange('year', value);
    const handleChangePurchaseDate = value => this.handleChange('purchaseDate', value);
    const handleChangeEstimatedValue = value => this.handleChange('estimatedValue', value);
    const handleChangeAssetColorID = value => this.handleChange('assetColorID', value);
    const textProps = {
      data: asset,
      onChange: this.handleChange,
      entity: 'Asset'
    };
    return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", null, "Profile"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, _extends({
      label: "VIN / Serial",
      field: "serial"
    }, textProps))), /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(DateTimePicker, {
      onChange: handleChangeYear,
      label: "Year",
      defaultValue: year
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, _extends({
      label: "Manufacturer",
      field: "manufacturer"
    }, textProps))), /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, _extends({
      label: "Model",
      field: "model"
    }, textProps)))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(DateTimePicker, {
      onChange: handleChangePurchaseDate,
      label: "Purchase Date",
      defaultValue: purchaseDate
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: "Est. Value",
      value: estimatedValue,
      entity: "Asset",
      field: "estimatedValue",
      onChange: handleChangeEstimatedValue
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(TextInput, _extends({
      label: "Plate / Reg #",
      field: "plateRegNumber"
    }, textProps))), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "Color",
      labelKey: "name",
      onChange: handleChangeAssetColorID,
      options: assetColor.list,
      placeholder: "Select...",
      value: assetColorID,
      returnValueKey: "id",
      searchable: false
    }))));
  }
}
AssetProfile.propTypes = {
  asset: PropTypes.shape({
    id: PropTypes.string,
    assetColorID: PropTypes.string,
    estimatedValue: PropTypes.number,
    purchaseDate: PropTypes.string,
    year: PropTypes.string,
    serial: PropTypes.string
  }).isRequired,
  assetActions: PropTypes.shape({
    change: PropTypes.func,
    handleChange: PropTypes.func
  }).isRequired,
  assetColor: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetColorActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired
};
export { AssetProfile as TestAssetProfile };
export default entityComposition(AssetProfile, ['assetColor']);